import React, { useState } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axios";

const EventPaymentForm = ({ bookingId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    try {
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/event-payment-success`,
        },
      });

      if (error) {
        console.error("Payment confirmation error:", error);
        toast.error("Payment failed. Please try again.");
      } else {
        // Payment succeeded, confirm booking
        await axiosInstance.post("/news_and_events/event-payment-confirmation/", {
          booking_id: bookingId,
        });
        toast.success("Payment successful!");
      }
    } catch (error) {
      console.error("Payment error:", error);
      toast.error("An error occurred during payment.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="payment-form">
      <PaymentElement />
      <button
        type="submit"
        disabled={!stripe || isProcessing}
        className="btn btn-primary btn-lg w-100 mt-3"
      >
        {isProcessing ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default EventPaymentForm;
